import React from 'react'

const CaretRight = ({color}) => {
  return (
    <svg viewBox="0 0 10.7 20">
      <path
        fill={color}
        d="M10.7,9.9c0,0.2-0.1,0.3-0.2,0.5l-9.4,9.4c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.3,0
	c-0.1,0-0.2-0.1-0.2-0.1C0.1,19.7,0,19.5,0,19.3c0-0.2,0.1-0.3,0.2-0.5l8.9-8.9L0.3,1.2C0.2,1,0.1,0.9,0.1,0.7
	c0-0.2,0.1-0.3,0.2-0.5C0.5,0.1,0.6,0,0.8,0s0.3,0.1,0.5,0.2l9.2,9.3C10.7,9.6,10.7,9.7,10.7,9.9z"/>
    </svg>
  )
}

export default CaretRight
